import React, { useEffect } from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'
import { Carousel, Image } from '@lounge-fe/ui-kit'
import type { ImageCarouselBlockProps } from '../BlockRenderer/types'

export const ImageCarouselBlock: React.FC<ImageCarouselBlockProps> = ({
  blocks: slides,
  autoplay,
  autoplaySpeed,
  showControls,
  loop,
}) => {
  const [emblaRef, embla] = useEmblaCarousel(
    {
      align: 'start',
      containScroll: 'trimSnaps',
      skipSnaps: false,
      loop,
      slidesToScroll: 1,
    },
    [WheelGesturesPlugin()],
  )

  useEffect(() => {
    if (!autoplay || !embla) return

    const autoplayInterval = setInterval(() => {
      if (embla.canScrollNext()) {
        embla.scrollNext()
      } else if (loop) {
        embla.scrollTo(0)
      } else {
        clearInterval(autoplayInterval)
      }
    }, autoplaySpeed)

    return () => clearInterval(autoplayInterval)
  }, [embla, autoplay, autoplaySpeed, loop])

  if (!slides || slides.length === 0) return null

  const slideImages = slides.map((slide) => slide.settings.image)

  return (
    <div className="image-carousel relative w-full h-full">
      <Carousel emblaRef={emblaRef} embla={embla}>
        <Carousel.Viewport showOverflow={false} className="w-full h-full">
          <Carousel.Container className="auto-cols-[100%] gap-x-0 h-full">
            {slideImages.map((image, index) => (
              <Carousel.Slide
                key={`${image.src}-${index}`}
                index={index}
                className="w-full h-full"
              >
                <div className="aspect-[4/3] md:h-full w-full">
                  <Image
                    data={{
                      src: image.src,
                      width: 472,
                      height: 708,
                    }}
                    width={472}
                    height={708}
                    loading="lazy"
                    alt={image.alt}
                    className="w-full h-full object-cover object-top md:object-center"
                  />
                </div>
              </Carousel.Slide>
            ))}
          </Carousel.Container>
        </Carousel.Viewport>
        {showControls && (
          <Carousel.Arrows className="absolute bottom-0 left-0 right-0 pointer-events-none flex items-center justify-between p-2 sm:p-4 [&_button]:pointer-events-auto [&_button]:!w-10 [&_button]:!h-10 [&_button]:bg-white " />
        )}
      </Carousel>
    </div>
  )
}
